import { ChangeDetectorRef, Component, OnInit,ViewContainerRef,ViewChild,ComponentFactoryResolver, Input } from '@angular/core';
import { AspInvoiceDetailsService } from './asp-invoice-details.service';
import { ActivatedRoute,Router } from '@angular/router';
import { AspRequestDetailsService } from '../asp-request-details/asp-request-details.service';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from 'ngx-toastr';
import { AspRecordPaymentComponent } from '../asp-record-payment/asp-record-payment.component';
import { Location } from '@angular/common';
import { AspLoadingService } from '../asp-loading/asp-loading.service'; 
import { AspCustomerPaymentsListService } from 'app/asp-customer-payments-list/asp-customer-payments-list.service';

import { AspCustomerQuoteService } from '../asp-customer-quote/asp-customer-quote.service';
import { GlobalVariable } from 'app/main/globals';
import {SearchSuggestionService} from 'app/shared/search-suggestion.service'
import { AspProductDetailsService } from '../../auto-spare-parts/asp-product-details/asp-product-details.service';
import { AspCheckinReportsService } from '../asp-checkin-reports/asp-checkin-reports.service';

interface FilterOption {
  label: string;
  value: string;
  checked: boolean;
  children?: FilterOption[];
}

interface Filters {
  jobCardStatus: FilterOption[];
}
@Component({
  selector: 'app-asp-invoice-details',
  templateUrl: './asp-invoice-details.component.html',
  styleUrls: ['./asp-invoice-details.component.scss']
})
export class AspInvoiceDetailsComponent implements OnInit {
  isBottomSheetOpen= false;
  data: any;
  details: any;
  items: any;
  openInvoice: boolean;
  selectAllQuote: boolean;
  customerQuotation: any = [];
  customerQuotation1: any=[];
  selectedItemsLabourQuote: any;
  selectedItemsQuote: any;
  selectedItemsCountQuote: any;
  selectedItemsapprovedQuote: any;
  selectedItemsCountapprovedQuote: number;
  selectedAlreadyApprovedQuoteLabourlength: number;
  selectedAlreadyApprovedQuote: any;
  selectedAlreadyApprovedQuotelength: number;
  totalSelectedPriceQuote: any;
  totalapproveSelectedPriceQuote: any;
  totalEditSelectedPriceQuote: any;
  selectedLabours: any;
  selectedLabourslength: any;
  totallabourSelectedPrice: any;
  totalSelectedApprovedriceQuote: any;
  customerQuotationPrice: any;
  selectedLaboursCount: any;
  selectedItemsCount: any;
  totalSelectedEditPriceQuote: any;
  selectedItemsLabour: any;
  isSidebarOpen: boolean;
  searchText: string;
  filteredItems: any[];
  selectedLabourCount: number;
  itemQuote: any;
  isPopupOpenEdit: boolean;
  isAddLabour: boolean;
  labourListData: any;
  filteredItems1: any[];
  isEditLabourSidebarOpen: boolean;
  selectedLabour: any;
  labourName: any;
  labourAmount: any;
  labourId: any;
  id: any;
  customerquoteId: any;
  EdititemsCount: any;
  searchWord: string;
  customerQuotationCount: any;
  totalSelectedPriceQuote1: any;
  totalMRP: any;
 laborDetails: FormGroup;
  unitPrice: FormGroup;
  variantKey: string;
  partNumber: any;
  showCancelConfirmation: boolean;
  isPopupOpen: boolean;
  showSkipConfirmation: boolean;
  selectedItems: any;
  resData: any;
  totalQuantity: any;
  totalAmounts: any;
  taxableAmount: any;
  isVisible: boolean;
  cgst: any;
  sgst: any;
  items123: any;
  successIcon: any = '../../../../assets/icons/icons8-ok.gif';
  container: any;
  sidebarOpen: boolean;
  @Input() resIds!: string;
  @Input() jobcardId!: string;
  @Input() QuoteId!: string;
  activeUrl: string;
  isJobCardDetails: boolean;
  labourQuotationPrice: number;
  quoteGrandTotal: number;
  itemQuotesEdit: any;
  confirmedInvoicePopup: boolean;
  date: any;
  fullLabourList: any;
  totalSelectedPriceQuote2: any;
  newItem: any;
  newItems: any;
  itemForm: FormGroup;
  originalData: any;
  gstOptions: number[] = [5, 12, 18, 28];
  showExtraDiscountBottomSheet = false;
  discountType: 'rupees' | 'percentage' | null;
  discountValue: number | null | 0.0;
  showInfoPopup: boolean = false;
  discountInRupees: number = 0;
  discountInPercent: number = 0;
  calculatedDiscount: number = 0;
  nonStop: boolean = false;
  showGstColumn: number;
  toggle: any;
  paymentListDataReceipt: any;
  customerPaymentsReceipt: any;
  originalCustomerPaymentsReceipt: any[];
  filteredPaymentListData: any;
  isDiscountInvalid: boolean;
  grandTotalDisplay: any;
  searchActive: boolean = false;
  itemSuggestions: any[] = [];
  showSuggestionList = false;
  suggestions: { value: string; type: string }[] = []; // Updated type
  selectedSuggestions: Set<string> = new Set<string>();
  isInputVisible = false;
  isSearchOpen = false;
  searchTimeout: any;
  selectedGst: number | null = null;
  rateCardApplicable: any;
  carSize: any;
  status: number;
   mainForm: FormGroup;
    quoteFormArray: FormArray;
    itemDiscountType: any;
    itemDiscountValue: any;
    isInitializingForm: boolean = false;

  constructor(
    public searchSuggestionService:SearchSuggestionService,
    private aspProductDetailsService: AspProductDetailsService,
    private aspInvoiceDetailsService:AspInvoiceDetailsService,
    private route:ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private aspRequestDetailsService:AspRequestDetailsService,
    private toastr: ToastrService,
    private _formBuilder: FormBuilder,
    private router:Router,
    private resolver: ComponentFactoryResolver,
    private location: Location,    
    private aspLoadingService: AspLoadingService,
    // private aspRecordPaymentComponent: AspRecordPaymentComponent,
    private aspCustomerQuoteService:AspCustomerQuoteService,
    private aspCustomerPaymentsListService: AspCustomerPaymentsListService,
    private fb: FormBuilder,
    private aspCheckinReportsService: AspCheckinReportsService,
  ) { 
    this.itemForm = new FormGroup({
      itemName: new FormControl('', Validators.required),
      partNumber: new FormControl('', Validators.required),
      brand: new FormControl('', Validators.required),
      hsn: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{4,8}$')]), // HSN validation (4-8 digits)
      gst: new FormControl('', Validators.required), // Dropdown selection required
      unitPrice: new FormControl('', [Validators.required, Validators.min(0)]) // Unit price must be > 0
    });
  }

  statusList = [
    { label: 'Draft', value: '1', checked: false, statusclass: 'delivered-status'},
    { label: 'Confirmed', value: '2', checked: false, statusclass: 'confirmed-status'},
    { label: 'Partially Paid', value: '3', checked: false, statusclass: 'Partiallypaid-status'},
    { label: 'Paid', value: '4', checked: false, statusclass: 'Paid-status'},
     ];
  filters: Filters = {
    jobCardStatus: this.statusList,
  }

  ngOnInit(): void {
    this.activeUrl = this.router.url;
    this.isJobCardDetails = this.activeUrl.includes('/my-job-cards-details');
  
    this.route.queryParams.subscribe(params => {
      this.resIds = this.resIds || params['id'];
      this.jobcardId = this.jobcardId || params['jobcardId'];
      this.QuoteId = this.QuoteId || params['QuoteId'];
      this.invoiceDetails();
  
      this.laborDetails = this._formBuilder.group({
        labourName: ['', [Validators.required, Validators.minLength(2)]],
        labourAmount: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      });
  
      this.unitPrice = this._formBuilder.group({
        unitprice: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]]
      });
    });
    this.quoteFormArray = this.fb.array([]);
    this.mainForm = this.fb.group({
      quoteFormArray: this.quoteFormArray
    });
    // ✅ Get stored toggle value from localStorage (if needed)
    const storedToggle = localStorage.getItem('gstToggle');
    const isChecked = storedToggle === '1';  // fallback default: false
  
    // ✅ Call toggleSlider with proper value
    this.toggleSlider(isChecked);
    this.labourList();
  }
  
  

    @ViewChild('dynamicContainer', { read: ViewContainerRef }) recordpaymentcontainer!: ViewContainerRef;
  
  openSidebarQuote(){
    this.openInvoice=true;
    this.isBottomSheetOpen=false;
    this.getQuoteGrandTotal();
    this.selectAllQuote = false;
  }

  CloseSidebarQuote(){
    this.openInvoice=false;
  }
  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }
  getMakeImageUrl(make: string): string {
    if(make){
      const makeWithoutSpaces = make.toLowerCase().replace(/\s+/g, '');
      return `https://cube.getpitstop.com/assets/img/${makeWithoutSpaces}.png`;
    }else {
      return
    }
  }
  AddItems()
  {
    this.isSidebarOpen = !this.isSidebarOpen;
    this.searchText = '';
    this.filteredItems = [];
  }
  resId(id){
    this.resIds=id;
  }
  openMenu() {
    this.isBottomSheetOpen = true;
  }
  closeMenu(): void {
    this.isBottomSheetOpen = false;
  }
    shareForApproval(): void {
      let garageName = localStorage.getItem('spareSelectedGarageName');
      let garageKey = localStorage.getItem('garageKey');
      const combinedPath = `${this.data.invoiceId}/${this.jobcardId}/${garageKey}/${this.toggle}`;
      const encodedPath = btoa(combinedPath);

      const message = `Hello *${this.details.customerName}*,\n\n` +
      `We hope you're doing well! 😊\n\n` +
      `Your invoice for Registration Number: *${this.details?.registrationNumber}* is ready.\n\n` +
      `You can view the invoice here: ${GlobalVariable.AUTOVERSE_WEB}/invoice/${encodedPath} \n\n ` +
      // `To make the payment, please use the link below:\n${this.paymentLink}\n\n` +
      `Thank you for choosing *${garageName}*! We appreciate your business. If you have any questions, feel free to reach out.\n\n` +
      `Best regards,\n*${garageName}* Team 🙏`;
  
      // window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');
  const messageLink = `/invoice/${encodedPath}`;
   const carDetails = `${this.details?.make} ${this.details?.model} - ${this.details?.fuelType} - ${this.details?.variant} - ${this.details?.year}`;

    const messagePayload = {
    v1: garageName,                        // garage name
    v2: String(this.jobcardId),                                   // job card id
    v3: carDetails,                                   
    v4: this.details?.registrationNumber,               
    v5: '', 
    id: messageLink,
    to: String(this.details?.customerPhoneNumber)                    
  };

  // Send via WhatsApp API
  this.aspCheckinReportsService.sendWhatsAppMessage('sendInvoice', messagePayload).subscribe(
    res => {
      console.log('WhatsApp message sent', res);
      this.closeMenu();
    },
    err => {
      console.error('Failed to send WhatsApp message', err);
    }
  );
    }
  
    async downloadPDF() {
      this.aspLoadingService.show();
      const html2pdfModule = await import('html2pdf.js');
      const html2pdf = html2pdfModule.default || html2pdfModule; // Ensure correct import
    
      const element = document.getElementById('invoiceContent');
    
      if (!element) {
        console.error('Element not found!');
        return;
      }
    
      const options = {
        margin: [5, 5, 5, 5], // Small margin to prevent shifting
        filename: 'invoice.pdf',
        image: { type: 'jpeg', quality: 1.0 },
        html2canvas: {
          scale: 2, 
          useCORS: true, 
          logging: false,
          scrollX: 0,
          scrollY: 0,
          windowWidth: document.documentElement.scrollWidth, // Ensures correct width
          windowHeight: document.documentElement.scrollHeight, // Ensures full content
        },
        jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      };
    
      // Apply styles to prevent alignment issues
      // element.style.width = '800px'; // Adjust width to match the original design
      // element.style.padding = '20px'; // Ensure proper spacing
      // element.style.boxSizing = 'border-box'; // Prevent overflow
      element.style.top='20px'
      
      // Delay execution to ensure rendering is completed
      await new Promise((resolve) => setTimeout(resolve, 100));
    
      html2pdf().from(element).set(options).save();
      this.aspLoadingService.hide();
    }
// invoiceDetails(){
//   this.aspLoadingService.show();
//   let garageKey=localStorage.getItem('garageKey');
//   this.aspInvoiceDetailsService.invoiceDetails(this.resIds, this.jobcardId, garageKey).subscribe(
//     result => {
//       console.log("invoice-details-response",result)
//       this.aspLoadingService.hide();
//       if (result['code'] === 200){
//         this.data=result['data'];
//         console.log("this.data----",this.data);
//         this.details=result['data'].bookingJobCardResponse;
//          this.details = result['data'].bookingJobCardResponse;

//         this.rateCardApplicable = this.details.rateCardApplicable;
//         this.carSize = this.details.carSize;


//         console.log("Rate Card:", this.rateCardApplicable);
//         console.log("Car Size:", this.carSize);
//         this.items123=(result['data'].invoiceResponseList || []);
        
//         console.log("meghana--", this.items123);
//         this.customerQuotation=(result['data'].invoiceResponseList || []).filter(labour => labour.itemType == 'spare');
//         this.EdititemsCount=(result['data'].invoiceResponseList || []).filter(labour => labour.itemType == 'spare').length;
//         this.customerQuotation1=(result['data'].invoiceResponseList || []).filter(labour => labour.itemType == 'spare');
//               if(this.customerQuotation)
//       {

//         // setTimeout(() => {
//         //   const formArray = this.mainForm.get('quoteFormArray') as FormArray;

//         //   if (formArray && formArray.controls?.length > 0) {
//         //     formArray.controls.forEach((control, i) => {
//         //       const discountPercentage = +control.get('discountPercentage')?.value || 0;
//         //       const discountValue = +control.get('discountValue')?.value || 0;

//         //       if (discountPercentage > 0) {
//         //         this.onDiscountPercentageInput(i);
//         //       } else if (discountValue > 0) {
//         //         this.onDiscountValueInput(i);
//         //       }
//         //     });
//         //   }
//         // }, 0);
// setTimeout(() => {
//   const formArray = this.mainForm.get('quoteFormArray') as FormArray;

//   if (formArray && formArray.controls?.length > 0 && !this.isInitializingForm) {
//     formArray.controls.forEach((control, i) => {
//       const discountPercentage = +control.get('discountPercentage')?.value || 0;
//       const discountValue = +control.get('discountValue')?.value || 0;

//       if (discountPercentage > 0) {
//         this.onDiscountPercentageInput(i);
//       } else if (discountValue > 0) {
//         this.onDiscountValueInput(i);
//       }
//     });
//   }

//   this.isInitializingForm = false; // 👈 Reset after patching
// }, 0);

//       }
//         this.selectedItemsLabourQuote = (result['data'].invoiceResponseList || []).filter(
//           labour => labour.itemType == 'labour'
//         );
        
//         this.selectedItemsLabourQuote.forEach(labour => {
//           labour.labourName = labour.itemName;
//           labour.labourAmount = labour.sellingPrice;
//         });
//         // this.customerQuotation.forEach((quote, index) => {
//         //   const group = this.fb.group({
//         //     discountValue: [quote.discountValue || 0],
//         //     discountPercentage: [quote.discountPercentage || 0]
//         //   });
//         //   this.quoteFormArray.push(group);
//         // });
//         this.isInitializingForm = true; 
// this.quoteFormArray.clear(); // Clear if needed

// this.customerQuotation.forEach((item, index) => {
//   const isPercentage = item.discountType === 'percentage';

//   const group = this.fb.group({
//     discountValue: [!isPercentage ? item.discountValue : null],
//     discountPercentage: [isPercentage ? item.discountValue : null],
//     discountType: [item.discountType || 'amount']
//   });

//   group.valueChanges.subscribe(discount => {
//     this.recalculateMrpWithDiscount(index, discount);
//   });

//   this.quoteFormArray.push(group);
// });



      
//         this.selectedItemsLabour=(result['data'].invoiceResponseList || []).filter(labour => labour.itemType == 'labour');
//         this.totalQuantity = this.data.invoiceResponseList.reduce((sum, item) => sum + Number(item.quantity), 0);
//         this.discountType = this.data['discountType'];
//         this.discountValue = this.data['discountValue'];
//         // console.log("this.discountType",this.discountType);
//         // console.log("this.discountValue",this.discountValue);
//         this.labourList();
//         this.fetchInvoices();
        
//       }
//     });  
// }
invoiceDetails() {
  this.aspLoadingService.show();
  const garageKey = localStorage.getItem('garageKey');

  this.aspInvoiceDetailsService.invoiceDetails(this.resIds, this.jobcardId, garageKey).subscribe(
    result => {
      console.log("invoice-details-response", result);
      this.aspLoadingService.hide();

      if (result['code'] === 200) {
        this.data = result['data'];
        this.details = this.data.bookingJobCardResponse;

        this.rateCardApplicable = this.details.rateCardApplicable;
        this.carSize = this.details.carSize;

        this.items123 = this.data.invoiceResponseList || [];

        // Compute correct customerQuotation with discountedMrp
        this.customerQuotation = (this.data.invoiceResponseList || [])
          .filter(item => item.itemType === 'spare')
          .map(item => {
            const mrp = item.originalMrp ?? item.mrp ?? 0;
            const discountType = item.discountType;
            const discountValue = item.discountValue ?? 0;

            let discountAmount = 0;
            if (discountType === 'percentage') {
              discountAmount = (mrp * discountValue) / 100;
            } else if (discountType === 'rupees') {
              discountAmount = discountValue;
            }

            const finalMrp = mrp - discountAmount;

            return {
              ...item,
              discountType,
              discountValue,
              discountedMrp: finalMrp >= 0 ? finalMrp : 0,
              isDiscountInvalid: discountAmount > mrp
            };
          });

        this.EdititemsCount = this.customerQuotation.length;
        this.customerQuotation1 = [...this.customerQuotation];

        // Patch form values if customerQuotation is available
        if (this.customerQuotation) {
          setTimeout(() => {
            const formArray = this.mainForm.get('quoteFormArray') as FormArray;
            if (formArray && formArray.controls?.length > 0) {
              formArray.controls.forEach((control, i) => {
                const discountPercentage = +control.get('discountPercentage')?.value || 0;
                const discountValue = +control.get('discountValue')?.value || 0;

                if (discountPercentage > 0) {
                  this.onDiscountPercentageInput(i);
                } else if (discountValue > 0) {
                  this.onDiscountValueInput(i);
                }
              });
            }

            this.isInitializingForm = false;
          }, 0);
        }

        // Labour data setup
        this.selectedItemsLabourQuote = (this.data.invoiceResponseList || []).filter(
          labour => labour.itemType == 'labour'
        );

        this.selectedItemsLabourQuote.forEach(labour => {
          labour.labourName = labour.itemName;
          labour.labourAmount = labour.sellingPrice;
        });

        this.selectedItemsLabour = [...this.selectedItemsLabourQuote];

        // Build FormArray
        this.isInitializingForm = true;
        this.quoteFormArray.clear();

        this.customerQuotation.forEach((item, index) => {
          const isPercentage = item.discountType === 'percentage';

          const group = this.fb.group({
            discountValue: [!isPercentage ? item.discountValue : null],
            discountPercentage: [isPercentage ? item.discountValue : null],
            discountType: [item.discountType || 'amount']
          });

          group.valueChanges.subscribe(discount => {
            this.recalculateMrpWithDiscount(index, discount);
          });

          this.quoteFormArray.push(group);
        });

        // Other data
        this.totalQuantity = this.data.invoiceResponseList.reduce(
          (sum, item) => sum + Number(item.quantity),
          0
        );

        this.discountType = this.data['discountType'];
        this.discountValue = this.data['discountValue'];

        this.labourList();
        this.fetchInvoices();
      }
    },
    error => {
      this.aspLoadingService.hide();
      console.error("Error fetching invoice details:", error);
    }
  );
}

toggleSlider(isChecked: boolean): void {
  console.log("isChecked",isChecked);
  console.log("this.toggle--", this.toggle);
  const garageKey = localStorage.getItem('garageKey');
  this.nonStop = isChecked;
  this.showGstColumn = isChecked ? 1 : 0;
  console.log("this.toggle--", this.toggle);
  const cleanData1 = {
    invoiceId: this.resIds,
    showGstColumn: this.showGstColumn,
    garageKey: garageKey,
  };

  this.aspInvoiceDetailsService.showGst(cleanData1).subscribe({
    next: (result: any) => {
      this.data = result;
      this.toggle = result.data;
      localStorage.setItem('gstToggle', this.toggle);
      // console.log("GST column updated:", this.showGstColumn);
      console.log("this.toggle--", this.toggle);
      // console.log("this.data---", this.data);
      this.invoiceDetails();

      // ✅ Store toggle status in localStorage
      // localStorage.removeItem('gstToggle');
    
    },
    error: err => {
      console.error("Error updating GST column:", err);
    }
  });
}


showGst
openSkipConfirmation(){
  this.showSkipConfirmation = true;
}
updateSelectedItemsQuote(): void {
  this.selectedItemsQuote = this.customerQuotation.filter(quote => quote.selected);
  this.selectedItemsCountQuote = this.customerQuotation.filter(quote => quote.selected).length;
  this.selectedItemsapprovedQuote = this.customerQuotation1.filter(quote => quote.selected);
  this.selectedItemsapprovedQuote = []; // Set a default empty array to prevent errors
  this.selectedItemsCountapprovedQuote = (this.customerQuotation1.filter(quote => quote.selected).length | 0)+(this.selectedItemsLabourQuote.filter(quote => quote.selected).length | 0);
  this.selectedAlreadyApprovedQuoteLabourlength=this.selectedItemsLabour.filter(quote => quote.selected).length | 0
  this.selectedAlreadyApprovedQuotelength=(this.customerQuotation1.filter(quote => quote.selected).length | 0)+(this.selectedItemsLabour.filter(quote => quote.selected).length | 0);
  this.selectedAlreadyApprovedQuote=(this.customerQuotation1.filter(quote => quote.selected).reduce((total, quote) => total+(quote.sellingPrice *quote.quantity), 0))+(this.selectedItemsLabour.filter(quote => quote.selected).reduce((total, quote) => total+(quote.labourAmount *quote.quantity),0))
  // this.totalSelectedPrice = this.totalSelectedPrice + ((bidItem.mrp - (bidItem.mrp* bidItem.sellingDiscount /100))*bidItem.itemQuantity);
  this.totalSelectedPriceQuote = this.customerQuotation.filter(quote => quote.selected).reduce((total, quote) => total+(quote.mrp *quote.itemQuantity), 0);
  this.totalapproveSelectedPriceQuote=this.customerQuotation.filter(quote => quote.selected).reduce((total, quote) => total+(quote.sellingPrice *quote.quantity), 0);
  this.totalEditSelectedPriceQuote=this.customerQuotation.filter(quote => quote.selected).reduce((total, quote) => total+(quote.sellingPrice *quote.quantity), 0);

}
sidebarToggleSelectAllQuote() {
 
  
  this.selectAllQuote = !this.selectAllQuote;

  // Ensure customerQuotation is defined before looping
  if (Array.isArray(this.customerQuotation)) {
    this.customerQuotation.forEach(quote => {
      quote.selected = this.selectAllQuote;
    });
  } else {
    console.log('error select all parts');   
   }
  // if (Array.isArray(this.customerQuotation1))
  // if (Array.isArray(this.customerQuotation1)) {alert("if condition 2")
  //   this.customerQuotation1.forEach(quote => {
  //     quote.selected = this.selectAllQuote;
  //   });
  // } else {
  //   console.log('error select all parts');   
  //  }
  // Ensure selectedItemsLabourQuote is defined before looping
  if (Array.isArray(this.selectedItemsLabourQuote)) {
    this.selectedItemsLabourQuote.forEach(labour => {
      labour.selected = this.selectAllQuote;
    });
  } else {
    console.log('error select all labour');
  }
  
  // if (Array.isArray(this.selectedItemsLabour)) {alert("if lavour sidebar2")
  //   this.selectedItemsLabour.forEach(labour => {
  //     labour.selected = this.selectAllQuote;
  //   });
  // } else {
  //   console.log('error select all labour');
  // }


  // this.selectedLaboursCount = this.selectedItemsLabourQuote.filter(labour => labour.selected).length;

  // Call other functions
  // this.labourList();
  this.updateSelectedItemsQuote();
  this.updateSelectedLabourItems();

  // Force Angular to detect changes
  this.cdr.detectChanges();
}


  updateSelectedLabourItems(): void {
    // Filter selected labour items
    this.selectedLabours = this.selectedItemsLabourQuote.filter(labour => labour.selected);
    this.selectedLabourslength = this.selectedLabours.length;
    // console.log("this.selected;abourLength---",this.selectedLabourslength);
  
    
    // Ensure the total price is calculated correctly
    this.totallabourSelectedPrice = this.selectedLabours.reduce((sum, labour) => {
      return sum + ((labour.labourAmount * labour.quantity)|| 0);
    }, 0);
  
    // Ensure total approved price is updated correctly
    this.totalSelectedApprovedriceQuote = (this.totallabourSelectedPrice || 0) + (this.totalapproveSelectedPriceQuote || 0);
    this.customerQuotationPrice = this.totalSelectedApprovedriceQuote;
  
    // Update counts
    this.selectedLaboursCount = this.selectedLabours.length || 0;
    this.selectedItemsCount = this.selectedLabourslength + (this.selectedItemsCountQuote || 0);
    // console.log("total items----",this.totallabourSelectedPrice);
    // console.log("labourPrice -------",this.totalEditSelectedPriceQuote);
    // this.totalEditItemsPrice=(this.totallabourSelectedPrice || 0)+(this.totalEditSelectedPriceQuote || 0);
    // console.log("this.totalEditSelectedPriceQuote--",this.totalEditSelectedPriceQuote);
    this.totalSelectedEditPriceQuote = (this.totallabourSelectedPrice || 0) + (this.totalEditSelectedPriceQuote || 0);
  
    // --------------------------------Discount--------------------------------
// console.log("this.discountType",this.discountType);
// console.log("this.discountValue",this.discountValue);
// discouunt type and discount values
if (this.discountType === 'rupees') {
  this.calculatedDiscount = this.discountValue;
} else if (this.discountType === 'percentage') {
  this.calculatedDiscount = (this.totalSelectedEditPriceQuote * this.discountValue) / 100;
}
// console.log("this.calculatedDiscount---",this.calculatedDiscount);
// ------------------------------------------------------------------------
    // Ensure UI reflects the changes
    this.cdr.detectChanges();
  }
  sidebarToggleItemSelectionQuote(){
    this.toggleItemSelectionQuote();

  }
  toggleItemSelectionQuote(): void {
    if (Array.isArray(this.customerQuotation)) {
      this.selectAllQuote = this.customerQuotation.every(quote => quote.selected);
    } else {
      this.selectAllQuote = false;
    }
    //  // if (Array.isArray(this.customerQuotation1))
    //  if (Array.isArray(this.customerQuotation1)) {alert("items")
    //   this.customerQuotation1.forEach(quote => {
    //     quote.selected = this.selectAllQuote;
    //   });
    // } else {
    //   this.selectAllQuote = false;  
    //  }
  
    if (Array.isArray(this.selectedItemsLabourQuote)) {
      this.selectedItemsLabourQuote.forEach(labour => {
        labour.selected = labour.selected ? true : false;
      });
  
      this.selectedLabourCount = this.selectedItemsLabourQuote.filter(labour => labour.selected).length;
    }
     else {
      this.selectAllQuote = false;
      this.selectedLabourCount = 0;
    }

    
  
    // Ensure selectedItemsLabourQuote is updated
    this.updateSelectedItemsQuote();
    this.updateSelectedLabourItems();
  
    // Force UI update
    this.cdr.detectChanges();
  }
  toggleItemSelectionLabour(): void {
    if (Array.isArray(this.selectedItemsLabourQuote)) {
      this.selectAllQuote = this.selectedItemsLabourQuote.every(labour => labour.selected);
      this.selectedLabourCount = this.selectedItemsLabourQuote.filter(labour => labour.selected).length;
    } else {
      this.selectAllQuote = false;
      this.selectedLabourCount = 0;
    }
  
    this.updateSelectedItemsQuote();
    this.updateSelectedLabourItems();
    this.cdr.detectChanges();
  }
   
  openEditDialog(itemQuotes){
    // console.log("itemQuotes",itemQuotes)
    this.itemQuote = [];
    this.itemQuote=itemQuotes;
    this.itemQuote['discountedPrice'] = this.calculateDiscountedPrice(itemQuotes.mrp, itemQuotes.discount);
    this.isPopupOpenEdit = true;
    this.selectedItemsCountQuote = 0;
    if (itemQuotes) {
      this.itemQuotesEdit = { ...itemQuotes };
     }
    // this.customerQuotation.forEach(quote => {
    //   quote.selected = false;
    // });
    // this.customerQuotation.forEach(quote => quote.selected = this.selectAllQuote=false);
  }
  calculateDiscountedPrice(mrp: number, discount: number): number {
    return mrp - (mrp * discount / 100);
  }
  closePopupEdit(): void {
    this.isPopupOpenEdit = false;
  }
  save(): void {
   const index = this.customerQuotation.findIndex(i => i.partNumber === this.itemQuote['partNumber']);

    // If the item exists, update it
    if (index !== -1 ) {
      this.itemQuotesEdit=this.up.unitprice.value
        // Update the item in the list with the new unit price and recalculate total amount
        this.customerQuotation[index].mrp =Number(this.up.unitprice.value);
        this.customerQuotation[index].sellingPrice =Number(this.up.unitprice.value);
        this.customerQuotation[index].totalAmount = this.up.unitprice.value * this.itemQuote['quantity'];
        }
          // Recalculate the total quotation price
    this.customerQuotationPrice = this.calculateTotalQuotationPrice();
    // Close the popup after saving
    this.closePopupEdit();
    this.updateSelectedItemsQuote();
    this.updateSelectedLabourItems();
    this.getQuoteGrandTotal();
  }
calculateTotalQuotationPrice(): number {
  // Recalculate total price by summing up all items' total amounts
  return this.customerQuotation.reduce((sum, item) => sum + (item.mrp * item.itemQuantity), 0);
}
decrementQuantity(quote: any): void {
  if (quote.quantity > 1) { 
    quote.quantity--;
    this.customerQuotationPrice = this.calculateTotalQuotationPrice();
    this.updateSelectedItemsQuote();
    this.updateSelectedLabourItems();
  }
}
incrementQuantity(quote: any): void {
  quote.quantity++;
  this.customerQuotationPrice = this.calculateTotalQuotationPrice();
  this.updateSelectedItemsQuote();
  this.getQuoteGrandTotal();
  this.updateSelectedLabourItems();

}
incrementjobcardQuantity(quote:any):void {
  quote.itemQuantity++;
  this.customerQuotationPrice = this.calculateTotalQuotationPrice();
  this.getQuoteGrandTotal();
  this.updateSelectedItemsQuote();
  this.updateSelectedLabourItems();
}
decrementjobcardQuantity(quote:any): void{
  if (quote.itemQuantity > 1) { 
    quote.itemQuantity--;
    this.customerQuotationPrice = this.calculateTotalQuotationPrice();
    this.getQuoteGrandTotal();
    this.updateSelectedItemsQuote();
    this.updateSelectedLabourItems();
  }
}
toggleSelectItem(): void {
  this.selectedItemsLabourQuote = this.fullLabourList.filter(item => item.selected);
  this.totalSelectedPriceQuote2 = this.selectedItemsLabourQuote.reduce(
    (sum, item) => sum + (item.sellingPrice || 0),0);
  this.totalSelectedPriceQuote1 = this.selectedItemsLabourQuote.reduce(
    (sum, item) => sum + (item.labourAmount || 0),0);
  this.isAddLabour = false;
  this.getQuoteGrandTotal();
  this.updateSelectedItemsQuote();
  this.updateSelectedLabourItems();
}
addLabourSidebar(){
  this.isAddLabour = !this.isAddLabour; 
  this.labourList();
  
}
// addLabour() {
  // console.log(this.ld.labourAmount.value);
//   const updatedLabourName = this.ld.labourName.value;
//   const updatedLabourAmount = this.ld.labourAmount.value;
//   const garageKey = localStorage.getItem('garageKey');

//   this.aspRequestDetailsService.addLabourList(garageKey, updatedLabourName, updatedLabourAmount)
//     .subscribe((result) => {
//       const res = JSON.parse(JSON.stringify(result));
//       if (res.code === 200) {
//         console.log("addLabour--", res);
        
//         const newLabour = {
//           labourName: updatedLabourName,
//           labourAmount: updatedLabourAmount,
//           selected: true, // Ensure it's checked by default
//           quantity: 1,
//           id: res.data?.id 
//         };

//         // Add it to the displayed list immediately
//         this.labourListData.unshift(newLabour);
//         this.selectedItemsLabourQuote.unshift(newLabour);
        
//         // Ensure the selected state is preserved in the labour list
//         this.labourList();

//         this.updateSelectedItemsQuote();
//         this.updateSelectedLabourItems();
//         this.toastr.success("Labour Added Successfully");
//       }

//       this.closeLabourEditSidebar();
//     });
// }
addLabour() {
  // console.log(this.ld.labourAmount.value);
  const updatedLabourName = this.ld.labourName.value;
  const updatedLabourAmount = this.ld.labourAmount.value;
  const garageKey = localStorage.getItem('garageKey');

  this.aspRequestDetailsService.addLabourList(garageKey, updatedLabourName, updatedLabourAmount,this.rateCardApplicable,this.carSize)
    .subscribe((result) => {
      const res = JSON.parse(JSON.stringify(result));
      if (res.code === 200) {
        // console.log("addLabour--", res);
        
        const newLabour = {
          labourId: res.data?.labourId,  // Ensure labourId is set
          labourName: updatedLabourName,
          labourAmount: updatedLabourAmount,
          id : res.data?.id,
          selected: true, // Ensure it's checked by default
          quantity: 1
        };

        // **Add to both lists**
        this.selectedItemsLabourQuote.unshift(newLabour);
        this.labourListData.unshift(newLabour);

        // Ensure selection consistency
        this.selectedItemsLabourQuote = [...this.selectedItemsLabourQuote];
        this.labourListData = [...this.labourListData];

        // **Force refresh labour list to sync selection**
        this.labourList();

        this.updateSelectedItemsQuote();
        this.updateSelectedLabourItems();
        this.toastr.success("Labour Added Successfully");
      }

      this.closeLabourEditSidebar();
    });
}

labourList() {  
  this.aspLoadingService.show();
  const garageKey = localStorage.getItem('garageKey');

  if (garageKey) {
      this.aspRequestDetailsService.displayLabourList(garageKey,this.rateCardApplicable,this.carSize).subscribe(
          (result) => {            
              this.aspLoadingService.hide();
              const res = JSON.parse(JSON.stringify(result));
              if (res.code === 200) {
                  console.log("labourres===============", res);
                  console.log("this.selectedItemsLabourQuote labourlist----", this.selectedItemsLabourQuote);

                  if (!Array.isArray(this.selectedItemsLabourQuote)) {
                      this.selectedItemsLabourQuote = [];
                  }

                  // Ensure labours in selectedItemsLabourQuote remain selected in the list
                  this.fullLabourList = res.data.map((labour: any) => {
                      const existingItem = this.selectedItemsLabourQuote.find(
                          (selectedItem: any) => selectedItem.labourId === labour.labourId
                      );

                      return {
                          ...labour,
                          selected: !!existingItem, // Mark as selected if present in selectedItemsLabourQuote
                          quantity: existingItem?.quantity ?? 1, // Use existing quantity, otherwise default to 1
                      };
                  });

                  // Sorting: Move selected items to the top
                  this.fullLabourList.sort((a, b) => Number(b.selected) - Number(a.selected));

                  this.labourListData = [...this.fullLabourList]; // Copy sorted list to labourListData
                  // console.log("Updated labourListData:", this.labourListData);
                  this.selectedLabours = this.labourListData.filter(labour => labour.selected);
                  this.selectedLabourslength = this.labourListData.filter(labour => labour.selected).length;
                  console.log("saikiran------",this.selectedLabourslength);
                  this.updateSelectedLabourItems();
                  this.getQuoteGrandTotal();
                  this.updateSelectedItemsQuote();
              }
          },
          (error) => {            
            this.aspLoadingService.hide();
            console.error('Error fetching labour list:', error);
          }
      );
  } else {    
    this.aspLoadingService.hide();
    console.warn('Garage key not found in localStorage.');
  }
}
 
openLabourEditSidebar(item: any = null) {
  this.isEditLabourSidebarOpen = true;
  // this.isAddLabour = item ? false : true;
  this.isSidebarOpen = false;
  if (item) {
    this.selectedLabour = { ...item };
    this.labourName = this.selectedLabour.labourName;
    this.labourAmount = this.selectedLabour.labourAmount;
    this.labourId = this.selectedLabour.labourId;
    this.id = this.selectedLabour.id;
  } else {
    this.selectedLabour = { name: '', price: null };
  }
}
anyItemSelectedQuote() {
  return this.selectedItemsCount > 0;
}
markAsCompleteUpdate(){
 let itemData = [];
 this.customerQuotation1.forEach(approved => {
  itemData.push({"id": approved.itemId, "quoteItemStatus": 1});
 });
 let labourItems=[];
 this.selectedItemsLabour.forEach(approved => {
  labourItems.push({"labourName": approved.labourName, "quoteItemStatus": 1});
 });
  let param = {
    "jobcardId":this.jobcardId,
    "customerQuoteId": this.customerquoteId,
    "customerQuoteItems": itemData,
    "labourQuoteItems": labourItems
    
  }
  
  this.aspCustomerQuoteService.markAsComplete(param).subscribe(response => {
    // this.resData = response['data'];
    console.error('response complete:',response );
    this.invoiceDetails();
    this.ngOnInit();
  });
}
toggleItemviewSelectionQuote(item, type) {
  if (type === 'view') {
    if (Array.isArray(this.customerQuotation1)) {
      let allSelected = true;
      this.customerQuotation1.forEach(quote => {
        if (quote === item) {
          quote.selected = !quote.selected; // Toggle the selected item
        }
        if (!quote.selected) {
          allSelected = false; // Check if all are selected
        }
      });
      this.selectAllQuote = allSelected;
    } else {
    }
  } else if (type === 'view') {
    if (Array.isArray(this.selectedItemsLabour)) {
      let allSelected = true;
      this.selectedItemsLabour.forEach(labour => {
        if (labour === item) {
          labour.selected = !labour.selected; // Toggle the selected item
        }
        if (!labour.selected) {
          allSelected = false; // Check if all are selected
        }
      });
      this.selectAllQuote = allSelected;
    } else {
    }
  }

  this.updateSelectedItemsQuote();
  this.updateSelectedLabourItems();
}
addItemToQuotation(item: any) {
  this.customerQuotationCount=this.customerQuotation.length;

  // Find an existing item with the same partNumber
  const existingItem = this.customerQuotation.find(quote => quote.partNumber === item.partNumber);

  if (existingItem) {
    // If found, increase the quantity
    existingItem.quantity += 1;
  } else {
    // Otherwise, add the new item to the list
    const newItem = {
      itemId: item.itemId,
      itemName: item.name,
      brand: item.brand,
      partNumber: item.partNumber,
      sellingPrice: item.mrp,
      mrp:item.mrp,
      originalMrp: item.sellingPrice,
      quantity: 1,
      hsnCode:item.hsnCode,
      gstRate : item.gstRate,
      selected: true,
      edt: new Date(),
      itemType:"spare"
    };
   this.customerQuotation.push(newItem);
    console.log("newItem",newItem);
    // this.customerQuotation.forEach(quote => quote.selected = this.selectAllQuote);

    const discountGroup = this.fb.group({
      discountValue: [0],
      discountPercentage: [0]
    });
    
    this.quoteFormArray.push(discountGroup);
    
    // Immediately calculate sellingPrice to avoid null
    this.recalculateMrpWithDiscount(this.customerQuotation.length - 1, discountGroup.value);
    
    // Now subscribe to future changes
    discountGroup.valueChanges.subscribe(discount => {
      const itemIndex = this.customerQuotation.findIndex(q => q.partNumber === item.partNumber);
      if (itemIndex !== -1) {
        this.recalculateMrpWithDiscount(itemIndex, discount);
      }
    });
    
  }
  this.isSidebarOpen = false;
  this.clearSearch();
  this.updateSelectedItemsQuote();

}
onLabourSearch(): void {
  // console.log('Search Triggered:', this.searchText);
  const query = this.searchText?.toLowerCase();

  if (query) {
      this.labourListData = this.fullLabourList.filter(item =>
          item.labourName?.toLowerCase().includes(query)
      );
  } else {
      // Reset to full list when search is cleared
      this.labourListData = [...this.fullLabourList];
  }

  // console.log('Filtered Items:', this.labourListData);
}


clearLabourSearch() { 
this.searchText = '';
this.labourListData = [...this.fullLabourList]; // Restore full list
}


clearSearch() {
  this.searchWord = '';
  this.labourList();
  // this.filteredItems = [];
}
// clearSearch() {
//   this.searchWord = '';

//   this.filteredItems = [];
// }
onLabourSelectionChange(labour: any): void {
  if (!labour) {
    console.error('Labour object is undefined');
    return;
  }

  // Update the selected property
  labour.selected = labour.selected || false;
  const newItem = {
    itemId: labour.id,
    labourId : labour.labourId,
    itemName: labour.labourName,
    labourName : labour.labourName,
    garageKey: labour.garageKey,
    partNumber: labour.partNumber,
    sellingPrice: labour.labourAmount,
    labourAmount : labour.labourAmount,
    itmQty : labour.quantity,
    quantity : labour.quantity,
    mrp:labour.labourAmount,
    selected: true,
    edt: new Date(),
    itemType:"labour"
  };
  this.selectedItemsLabourQuote.push(newItem);
  // console.log("saijkiran---",this.selectedItemsLabourQuote);
  // Sync the selected items list
  // this.selectedItemsLabourQuote = this.labourListData.filter(l => l.selected);
   this.selectedLabourCount = this.selectedItemsLabourQuote.every(labour => labour.selected).length;
   this.updateSelectedItemsQuote();
   this.updateSelectedLabourItems();
  
}
totalAmount(): number {
  return this.items.filter(item => item.selected).reduce((total, item) => total + item.price, 0);
}
totalAmountQuote(): number {
  return this.items.filter(quote => quote.selected).reduce((total, item) => total + item.price, 0);
}
toggleSelectAllQuote(): void {
  this.selectAllQuote = !this.selectAllQuote;
  this.customerQuotation.forEach(quote => quote.selected = this.selectAllQuote);
  this.updateSelectedItemsQuote();
}
calculateMRP(item: any): number {
  this.customerQuotation.forEach
  return (item.mrp - (item.mrp * item.sellingDiscount / 100)) * item.itemQuantity;
}
calculateTotalMRP(): void {
  this.totalMRP = this.items.reduce((total, item) => {
    return total + this.calculateMRP(item);
  }, 0);
}
get up() {
  return this.unitPrice.controls;
}
  
  get ld() {
    return this.laborDetails.controls;
  }
  closeLabourEditSidebar() {
    this.isEditLabourSidebarOpen = false;
      this.selectedLabour = { labourName: '', labourAmount: null };
    // this.isAddLabour=false;
    
  
  }
  saveLabour(): void {
    // console.log("Labour Name:", this.ld.labourName.value);
    // console.log("Labour Amount:", this.ld.labourAmount.value);
  
    const updatedLabourName = this.ld.labourName.value;
    const updatedLabourAmount = this.ld.labourAmount.value;
    const garageKey = localStorage.getItem('garageKey');
    const status = 1;
  // console.log("before labourId-----",this.labourId);
    this.aspRequestDetailsService
        .editLabour(this.id, this.labourId, garageKey, updatedLabourName, updatedLabourAmount,this.rateCardApplicable,this.carSize,status)
        .subscribe(
            (result) => {
                // console.log('API Response:', result);
                const res = JSON.parse(JSON.stringify(result));
  
                if (res.code === 200) {
                    // console.log('Labour edited successfully:', res);
                    this.toastr.success("Labour saved Successfully");
                // console.log("this. this.labourId",this.labourId);
                    let labourExists = false;
                    this.selectedItemsLabourQuote = this.selectedItemsLabourQuote.map(item => {
                        if (item.labourId === this.labourId) {  // Ensure matching by correct ID
                            labourExists = true;
                            return {
                                ...item,
                                labourName: updatedLabourName,
                                labourId:this.labourId,
                                labourAmount: updatedLabourAmount,
                                selected: true 
                            };
                        }
                        return item;
                    });
                    if (!labourExists) {
                        this.selectedItemsLabourQuote.push({
                            id: this.id,
                            labourId : this.labourId,
                            labourName : updatedLabourName,
                            labourAmount: updatedLabourAmount,
                            selected: true
                        });
                    }
  
                    // console.log("Updated selectedItemsLabourQuote:", this.selectedItemsLabourQuote);
                    this.getQuoteGrandTotal();  
                    // Refresh the labour list to reflect changes
                    this.labourList();
                } else {
                    console.warn('Unexpected response code:', res.code);
                }
            },
            (error) => {
                console.error('Error editing labour:', error);
            }
        );
  
    this.closeLabourEditSidebar();
  }
onSearch(item: any) {
  if (!this.searchWord.trim()) {
    return;
  }
  const garageKey=localStorage.getItem('garageKey');
  this.variantKey=localStorage.getItem('VariantKey');

  this.aspRequestDetailsService
    .searchItems(garageKey, this.searchWord, this.variantKey)
    .subscribe(
      (result) => {
        const res = JSON.parse(JSON.stringify(result));
        
        if (res.code === 200) {
          this.filteredItems = res.data;
          this.partNumber= res.data.map((item: any) => item.partNumber);
        } else {
          console.error('Search failed with code:', res.code);
        }
      },
      (error) => {
        console.error('Error during search:', error);
      }
    );
}
closeCancelPopup(): void {
  this.showCancelConfirmation = false;
}
openPopup(): void {
  this.showSkipConfirmation = false;
  this.isPopupOpen = true;
  this.isAddLabour = false;
  this.CloseSidebarQuote();
  this.submitDataUpdate(); 
}
closePopup(): void {
  this.isPopupOpen = false;
}
submitDataUpdate() {
  this.selectedItems = this.customerQuotation.filter(quote => quote.selected);

  const discountFormArray = this.quoteFormArray?.value || [];

  // ✅ Only pick percentage and assign directly
  const itemsData = this.selectedItems.map((item, index) => {
    const discountEntry = discountFormArray[index] || {};
    let discountType = '';
    let discountValue = 0;

    if (discountEntry.discountPercentage && discountEntry.discountPercentage > 0) {
      discountType = 'percentage';
      discountValue = discountEntry.discountPercentage;  // ✅ assign % directly like submitData
    }

    return {
      id: item.id || 0,
      partName: item.itemName,
      partNumber: item.partNumber,
      sellingPrice: item.mrp,
      itmQty: item.quantity,
      mrp: item.mrp,
      hsnCode: item.hsnCode,
      gstRate: item.gstRate,
      discountType:"percentage",
    discountValue:discountValue
    };
  });

  const labourItemsData = this.selectedLabours.map(labour => ({
    labourId: labour.labourId,
    labourName: labour.labourName || labour.itemName,
    labourAmount: labour.labourAmount || labour.sellingPrice,
    itmQty: labour.quantity
  }));

  const cleanData1 = {
    invoiceId: this.resIds,
    jobcardId: this.jobcardId,
    garageKey: this.data.garageKey,
    quoteId: this.QuoteId || 0,
    gstNumber: '',
    billingAddress: '',
    shippingAddress: '',
    customerQuoteItems: itemsData,
    labourQuoteItems: labourItemsData,
    registrationNumber: this.details?.registrationNumber,
    discountType: this.discountType,       // 🔸 untouched as per your design
    discountValue: this.discountValue      // 🔸 untouched as per your design
  };

  this.aspInvoiceDetailsService.submitDataUpdate(cleanData1).subscribe(
    response => {
      const res = JSON.parse(JSON.stringify(response));
      if (res.code === 200) {
        this.resData = res['data'];
      }
    },
    error => {
      console.error('Error submitting data:', error);
    }
  );
}

// submitDataUpdate() {
//   // console.log("this.quoteid----",this.QuoteId)

//   this.selectedItems = this.customerQuotation.filter(quote => quote.selected);
//    // Update selectedItems with discount data from the form array
// const discountFormArray = this.quoteFormArray?.value || [];

//   // ✅ Assign discountType and discountValue properly
//   this.selectedItems.forEach((item, index) => {
//     const discountEntry = discountFormArray[index] || {};
//     let discountType = '';
//     let discountValue = 0;

//     if (discountEntry.discountValue && discountEntry.discountValue > 0) {
//       discountType = 'rupees';
//       discountValue = discountEntry.discountValue;
//     } else if (discountEntry.discountPercentage && discountEntry.discountPercentage > 0) {
//       discountType = 'percentage';
//       discountValue = discountEntry.discountPercentage;
//     }

//     // ✅ Apply to item
//     item.discountType = discountType;
//     item.discountValue = discountValue;
//   });

// console.log("sai kiran----",this.selectedItems)
//   const itemsData = this.selectedItems.map(item => ({
//     id: item.id || 0,
//     partName: item.itemName,
//     partNumber: item.partNumber,
//     sellingPrice: item.mrp,
//     itmQty: item.quantity,
//     mrp: item.mrp,
//     hsnCode:item.hsnCode,
//     gstRate : item.gstRate,
//     discountType : item.discountType,
//     discountValue : item.discountValue,


//   }));
//   // console.log("this.selectedLabours---",this.selectedLabours);

//   // Prepare labourItems separately
//   const labourItemsData = this.selectedLabours.map(labour => ({
//     "labourId": labour.labourId,
//     "labourName": labour.labourName || labour.itemName ,
//     "labourAmount": labour.labourAmount || labour.sellingPrice,
//     "itmQty": labour.quantity

 
//   }));

//   // Construct the final request payload
//   const cleanData1 = {
    
//     "invoiceId": this.resIds,
//     "jobcardId": this.jobcardId,
//     "garageKey":this.data.garageKey,
//     "quoteId":this.QuoteId || 0,
//     "gstNumber": '',
//     "billingAddress": '',
//     "shippingAddress": '',
//     "customerQuoteItems": itemsData,
//     "labourQuoteItems": labourItemsData,
//      "registrationNumber": this.details?.registrationNumber,
//      discountType: this.discountType,            
//     discountValue: this.discountValue,
//   };
//   // Call the API with updated data
//   this.aspInvoiceDetailsService.submitDataUpdate(cleanData1).subscribe(response => {
//     const res = JSON.parse(JSON.stringify(response));
//     if (res.code === 200){
//     this.resData = res['data'];
//     }
//   }, error => {
//     console.error('Error submitting data:', error);
//   });
  
// }
anyItemSelected() {
  return this.selectedLabourslength > 0;
}
incrementLabourQuantity(quote: any): void {
  if (quote.quantity >= 1) {
    quote.quantity++;
  }

  // ✅ Recalculate labour price and update UI
  this.labourQuotationPrice = this.calculateTotalLabourPrice();
  this.updateSelectedItemsQuote();
  this.updateSelectedLabourItems();
  this.getQuoteGrandTotal();
  this.cdr.detectChanges();
}

decrementLabourQuantity(quote: any): void {
  if (quote.quantity > 1) { 
    quote.quantity--;
  }

  this.labourQuotationPrice = this.calculateTotalLabourPrice();
  this.updateSelectedItemsQuote();
  this.updateSelectedLabourItems();
  this.getQuoteGrandTotal();
  this.cdr.detectChanges();
}
getQuoteGrandTotal(){
  // console.log("this.customerQuotation---",this.customerQuotation);
  let partsTotal = 0;
  if(this.customerQuotation){
    partsTotal = this.customerQuotation?.reduce((sum, item) => sum + (item.mrp * item.quantity),0);
  }
// console.log("partsTotal------===----",partsTotal)
// console.log("labour selected ----====----",this.selectedItemsLabourQuote)

  let labourTotal = 0;
  if(this.selectedItemsLabourQuote){
    labourTotal = this.selectedItemsLabourQuote?.reduce((sum, item) => sum + (Number(item.labourAmount) * item.quantity),0);
  }
  this.quoteGrandTotal = partsTotal + labourTotal;
  // console.log("thiws.GrandTotal---=---=--",this.quoteGrandTotal);
}  


calculateTotalLabourPrice(): number {
  return this.selectedItemsLabourQuote.reduce(
    (sum, item) => sum + (Number(item.sellingPrice) * Number(item.quantity || 1)), 0
  );
}
labourRedirectSidebar()
{
  this.isAddLabour=false;
  this.selectedLabourCount=0;
}
closeSidebar1(){
    this.isPopupOpen = false;
    this.closeSidebar(true);
    // this.submitDataUpdate();
    this.invoiceDetails();
}
  closeSidebar(ishide: boolean) {
    this.isVisible = ishide;
  }
  closeAll(): void{
    this.isAddLabour = false;
    this.isEditLabourSidebarOpen = false;
  }  
  close(): void{
    this.openInvoice = false;
  }
  closeSkipConfirmation(): void {
    this.showSkipConfirmation = false;
  }
  // navigateToDetails() {
  //   this.router.navigate(['/my-job-cards-details', this.jobcardId, 0]);
  // }
  goBack(): void {
    this.location.back();
  }
  // ========record-payment================


  openRecordPaymentSidebar() {
    this.recordpaymentcontainer.clear();
  
    const factory = this.resolver.resolveComponentFactory(AspRecordPaymentComponent);
    const componentRef = this.recordpaymentcontainer.createComponent(factory);
  
    // Optional: Add a close method to remove the sidebar
    const componentInstance = componentRef.instance as AspRecordPaymentComponent;
    componentInstance.invoiceresponse(this.data);
    componentInstance.openSidebar(); 
    this.isBottomSheetOpen=false;
    // = () => {
    //   this.container.clear(); // Close sidebar when called
    // };
  }
  // closeSidebarnew(): void {
  //   this.sidebarOpen = false;
  // }
  confirmedInvoice(){
    const confirmData = {
      "invoiceId":  this.resIds,
      "confirmStatus": 2,
      "customerName": this.details.customerName,
      "customerPhoneNumber":this.details.customerPhoneNumber,
      "totalAmount": this.data.sumOfItemTotal,
      "garageKey": localStorage.getItem("garageKey")
    };
    this.aspInvoiceDetailsService.confirmInvoice(confirmData).subscribe(
      result => {
        if (result['code'] === 200){ 
          this.confirmedInvoicePopup=true;
          // console.log("result",result);
          this.date=result['data'].invoiceConfirmDate;
        }
        else {
          this.toastr.error(result['message']);
        }
      }
    )
    this.isBottomSheetOpen=false;
  }
  closePopupConfirm(){
    this.confirmedInvoicePopup=false;
    this.invoiceDetails();
  }
  shareForPayment(): void {
    let garageName = localStorage.getItem('spareSelectedGarageName');
    const message = ` 
🚗 Payment Request  

Dear *${this.details?.customerName}*, 👋  

Your car service is complete, and the total amount due is ₹ *${this.data?.amountPending}*.  

Please complete your payment by clicking the secure link below:  

🔗 *${this.data?.paymentLink}*  

Thank you for choosing us! 😊  

Regards,  
*${garageName}* Team 🙏
`;

    // window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');
    const messageLink = `${this.data?.paymentLink}`;
   const carDetails = `${this.details?.make} ${this.details?.model} - ${this.details?.fuelType} - ${this.details?.variant} - ${this.details?.year}`;
    const amountPending =`${this.data?.amountPending}`;
    const messagePayload = {
    v1: garageName,                        // garage name
    v2: String(this.jobcardId),                                   // job card id
    v3: carDetails,                                   
    v4: this.details?.registrationNumber,               
    v5: amountPending, 
    id: messageLink,
    to: String(this.details?.customerPhoneNumber)                    
  };

  // Send via WhatsApp API
  this.aspCheckinReportsService.sendWhatsAppMessage('paymentRequest', messagePayload).subscribe(
    res => {
      console.log('WhatsApp message sent', res);
      this.closeMenu();
    },
    err => {
      console.error('Failed to send WhatsApp message', err);
    }
  );

    // this.closeMenu();
  }

  createNewItems(){
    this.newItem=!this.newItem;
  }

  createItemSidebar(){
    this.newItem= false;
    this.newItems=!this.newItems;
    this.isSidebarOpen=false;
  }
  onSubmit() {
       if (this.itemForm.invalid) {
      Object.keys(this.itemForm.controls).forEach(field => {
        const control = this.itemForm.get(field);
        control?.markAsTouched({ onlySelf: true });
        control?.updateValueAndValidity(); // Ensure validation messages appear
      });
  
      this.scrollToFirstInvalidField();
      return;
    }
  
    // console.log('Form submitted successfully', this.itemForm.value);
  
    if (this.itemForm.valid) {
      // console.log('Form Submitted createNewItem', this.itemForm.value);
      const cleanData1 = {
        "garageKey": localStorage.getItem('garageKey'),
        "garageName": localStorage.getItem('spareSelectedGarageName'),
        "userName": localStorage.getItem('spareSelectedGarageName'),
        "userRole":localStorage.getItem('userType'),
        "partName": this.itemForm.value['itemName'],
        "partNumber":this.itemForm.value['partNumber'],
        "mrp": (this.itemForm.value.unitPrice / 100).toFixed(2),
        "gstRate": this.itemForm.value['gst'],
        "brandName":this.itemForm.value['brand'],
        "hsnCode": this.itemForm.value['hsn'],
        "make": this.details?.jobCard?.make,
        "model": this.details?.jobCard?.model,
        "variant":this.details?.jobCard?.variant,
        "rowKey": this.details?.jobCard?.rowKey,
        "variantKey": this.details?.jobCard?.variantKey
      };
    
      // Call the API with updated data
      this.aspCustomerQuoteService.createNewItem(cleanData1).subscribe(response => {
        const res = JSON.parse(JSON.stringify(response));
        // console.log("res123456789",res);
        this.originalData=res.data;
        const transformedData = {
          ...this.originalData, 
          brand:this.originalData.brandName,
          itemName: this.originalData.partName, 
          itemId: undefined, 
          quantity: 1, 
          sellingPrice:this.originalData.mrp
        };
        this.customerQuotation.push(transformedData);
        // console.log("this.customerQuotation",this.customerQuotation);
        // this.customerQuotationListCount = this.customerQuotation.length
        // console.log('Item added successfully:', this.customerQuotationListCount);
        this.customerQuotation.forEach(quote => quote.selected = this.selectAllQuote);  
  
  
        // this.customerQuotationCount=this.customerQuotation.length;
        this.isSidebarOpen = false;
        this.clearSearch();
        this.updateSelectedItemsQuote();
        this.getQuoteGrandTotal();
        this.itemForm.reset();
        
      }
    )
    }
    this.newItems=false;
  }
  scrollToFirstInvalidField() {
    const firstInvalidControl: HTMLElement = document.querySelector(
      ".ng-invalid.ng-touched"
    ) as HTMLElement;
  
    if (firstInvalidControl) {
      firstInvalidControl.scrollIntoView({ behavior: "smooth", block: "center" });
      firstInvalidControl.focus(); // Optional: Focus on the field
    }
  }
  // =============================== EXTRA DISCOUNT-BOTTOM-SHEET=======================
openExtraDiscountBottomSheet() {
  this.showExtraDiscountBottomSheet = true;
}

closeExtraDiscountBottomSheet() {
  this.showExtraDiscountBottomSheet = false;
}

setDiscountType(type: 'rupees' | 'percentage') {
  this.discountType = type;
}

// saveExtraDiscount() {
//   console.log('Extra Discount Applied:', {
//     type: this.discountType,
//     value: this.discountValue
//   });
//   this.closeExtraDiscountBottomSheet();
// }
saveExtraDiscount() {
  if (this.discountType === 'rupees') {
    this.calculatedDiscount = this.discountValue;
  } else {
    this.calculatedDiscount = (this.totalSelectedEditPriceQuote * this.discountValue) / 100;
  }
this.showExtraDiscountBottomSheet = false;
}
toggleInfoPopup() {
  this.showInfoPopup = !this.showInfoPopup;
}
getDiscountAmount(): number {
  if (!this.quoteGrandTotal) return 0;
  if (this.discountType === 'rupees') {
    return this.discountValue;
  } else {
    return (this.discountValue / 100) * this.quoteGrandTotal;
  }
}

getDiscountPercentage(): number {
  // console.log("!this.quoteGrandTotal",!this.quoteGrandTotal)
  if (!this.quoteGrandTotal) return 0;
  if (this.discountType === 'percentage') {
    return this.discountValue;
  } else {
    return (this.discountValue / this.quoteGrandTotal) * 100;
  }
}
// calculateDiscountPreview(index: number) {
//   const totalAmount = this.customerQuotation[index]?.totalAmount || 0;

//   if (this.discountType === 'rupees') {
//     this.discountInRupees = this.discountValue || 0;
//     this.discountInPercent = totalAmount
//       ? (this.discountInRupees / totalAmount) * 100
//       : 0;
//   } else {
//     this.discountInPercent = this.discountValue || 0;
//     this.discountInRupees = totalAmount
//       ? (this.discountInPercent / 100) * totalAmount
//       : 0;
//   } 
// }
displayDiscount(): number {
  // console.log("this.quoteGrandTotal",this.quoteGrandTotal);
  // console.log("this.discountValue",this.discountValue)
  this.grandTotalDisplay = this.data?.grandTotal
  if (this.discountType === 'rupees' ) {
    return (this.discountValue / this.quoteGrandTotal) * 100;
  }
  else{
    return (this.discountValue)
  }


}
calculateDiscountPreview(index: number) {
  const totalAmount = this.totalSelectedEditPriceQuote || 0;
  // console.log("this.customer without Index------", this.totalAmount);
  // console.log("this.totalAmount-----", this.customerQuotation[index]);

  // Check if discountValue is greater than totalAmount
  this.isDiscountInvalid = false;
  if ((this.discountType === 'rupees' && (this.discountValue || 0) > totalAmount) ||
  (this.discountType === 'percentage' && (this.discountValue || 0) > 100)) {
this.isDiscountInvalid = true;
}


  if (this.discountType === 'rupees') {
    this.discountInRupees = this.discountValue || 0;
    this.discountInPercent = totalAmount
      ? (this.discountInRupees / totalAmount) * 100
      : 0;
  } else {
    this.discountInPercent = this.discountValue || 0;
    this.discountInRupees = totalAmount
      ? (this.discountInPercent / 100) * totalAmount
      : 0;
  }
}

// ===============receipt-details=work============
fetchInvoices(): void {
  this.aspLoadingService.show();
  this.aspCustomerPaymentsListService.getAllInvoices().subscribe(
    (res: any) => {
      // console.log("customer-payment-list-response",res)
      this.aspLoadingService.hide();
      this.filteredPaymentListData = res?.data?.content?.filter(item =>  +item.invoiceId === this.data.invoiceId);
      // console.log("this.filteredPaymentListData",this.filteredPaymentListData)
       },
    (error) => {
      console.error('Error fetching invoices:', error);
    }
  );
}
openRecordPaymentSidebar1(paymentId,jobcardId) {
    this.isBottomSheetOpen=false;
    const factory = this.resolver.resolveComponentFactory(AspRecordPaymentComponent);
    const componentRef = this.recordpaymentcontainer.createComponent(factory);
    const componentInstance = componentRef.instance as AspRecordPaymentComponent;

    componentInstance.isReceiptSidebarOpen = true;
    componentInstance.openReceiptSidebar();
    componentInstance.jobcardId = jobcardId;
    componentInstance.paymentpopupId = paymentId;
    
    }

     // =========================BELOW CODE IS FOR SEARCH BY PART-NO AND PART NAME WHILE CREATING ITEM MANUALLY============================
  toggleTopSearchBar() {
  this.searchActive = !this.searchActive;
   this.searchText = '';
  this.suggestions = [];

  // Reset form only if search is being closed
  if (!this.searchActive) {
    this.itemForm.reset(); // Clear all auto-filled form fields
  }
}


    isFirstSuggestion(suggestion: string, index: number): boolean {
        // Check if it's the first suggestion and if it matches preSearchValue
        let preSearchValue=localStorage.getItem('preSearchValue');
        return index === 0 && preSearchValue === suggestion['value'];
    }
    sortSuggestionsByRelevance(suggestions: { value: string, type: string }[], searchText: string): { value: string, type: string }[] {
    const typePriority = {
        brand: 4,
        category: 3,
        partName: 2,
        partNumber: 1,
    };

    return suggestions?.sort((a, b) => {
        const relevanceA = this.getRelevance(a.value, searchText) + typePriority[a.type];
        const relevanceB = this.getRelevance(b.value, searchText) + typePriority[b.type];

        return relevanceB - relevanceA; 
    });
}
getRelevance(suggestion: string, searchText: string): number {
    if (suggestion?.toLowerCase() === searchText?.toLowerCase()) {
        return 3; 
    } else if (suggestion?.toLowerCase().startsWith(searchText?.toLowerCase())) {
        return 2; 
    } else if (suggestion?.toLowerCase().includes(searchText?.toLowerCase())) {
        return 1; 
    } else {
        return 0; 
    }
}
 private clearLocalStorage(){
        sessionStorage.removeItem('sparePartsDetails');
        localStorage.removeItem('vehicleType');
        // localStorage.removeItem('newMake');
        // localStorage.removeItem('newModel');
        // localStorage.removeItem('newYear');
        // localStorage.removeItem('newVariant');
        // localStorage.removeItem('newVariantKey');
        // localStorage.removeItem('newRowKey');
        localStorage.removeItem('isShippingCharges');
        localStorage.removeItem('prepayUpiDiscount');
        // localStorage.removeItem('vehicleData');
        // localStorage.removeItem('selectedModel');
        // localStorage.removeItem('selectedYear');
        // localStorage.removeItem('variant');
        // localStorage.removeItem('selectedFuel');
        // localStorage.removeItem('variantKey');
        // localStorage.removeItem('rowKey');
        localStorage.removeItem('selectedSparesList');
        localStorage.removeItem('preSearchValue');
    };
         toggleSearch() {
          this.isSearchOpen = !this.isSearchOpen;
        this.isInputVisible = !this.isInputVisible;
        if (this.isInputVisible) {
          setTimeout(() => {
            const input = document.querySelector('.SearchInput') as HTMLInputElement;
            if (input) {
              input.focus();
            }
          }, 0);
        }
      }
      onPartNumberClick(partNumber: string): void {
  this.searchText = partNumber;
  this.filterSuggestions();
}

filterSuggestions(): void {
  console.log('Filtering for:', this.searchText);
  if (this.searchText && this.searchText.length >= 3) {
    const rowKey = localStorage.getItem('rowKey');
    const variantKey = localStorage.getItem('variantKey');
    const universal = false;

    this.searchSuggestionService.getSearchSuggestions(rowKey, this.searchText, universal, variantKey)
      .subscribe((result: any) => {
        console.log('API response:', result);
        this.suggestions = [];

        if (result?.data?.brands?.length)
          this.suggestions.push(...result.data.brands.map((value: string) => ({ value, type: 'brand' })));

        if (result?.data?.categories?.length)
          this.suggestions.push(...result.data.categories.map((value: string) => ({ value, type: 'category' })));

        if (result?.data?.partNames?.length)
          this.suggestions.push(...result.data.partNames.map((value: string) => ({ value, type: 'partName' })));

        if (result?.data?.partNumbers?.length)
          this.suggestions.push(...result.data.partNumbers.map((value: string) => ({ value, type: 'partNumber' })));

        console.log('Suggestions after parsing:', this.suggestions);

        this.suggestions.reverse();
        this.suggestions = this.sortSuggestionsByRelevance(this.suggestions, this.searchText);
      });
  } else {
    this.suggestions = [];
  }
}

selectSuggestion(suggestion: { value: string; type: string }): void {
  this.searchText = suggestion.value;
  this.suggestions = [];

  // If needed, you can do something based on type:
  if (suggestion.type === 'partNumber') {
    // Load item or navigate
    console.log('Selected Part Number:', suggestion.value);
  }
}
onPartSelected(partNumber: string) {
  if (!partNumber) return;

  // Set input box to selected part number
  this.searchText = partNumber;

  this.suggestions = [];

  let garageKey = localStorage.getItem('garageKey');
  this.aspProductDetailsService.productDetails(garageKey, 'part-number', partNumber).subscribe({
    next: (res: any) => {
      if (res.code === 200 && res.data) {
        const product = res.data;

        this.itemForm.patchValue({
          itemName: product.name || '',
          partNumber: product.partNumber || '',
          brand: product.brand?.name || '',
          unitPrice: product.sellingPrice || product.mrp || '',
          hsn: product.hsnCode || '',  
          // gst:product.gstRate  || '',
        });
         // Convert gstRate decimal to percentage and assign to selectedGst
        this.selectedGst = product.gstRate ? Math.round(product.gstRate * 100) : null;
        this.addItemToQuotation(product);
      } else {
        this.toastr.error('Item details not found.');
      }
    },
    error: (err) => {
      console.error('Error fetching product details:', err);
      this.toastr.error('Item details not found.');
    }
  });
}

onItemNameInput(value: string) {
  clearTimeout(this.searchTimeout);

  if (value && value.length >= 2) {
    this.searchTimeout = setTimeout(() => {
      this.aspInvoiceDetailsService.searchB2BLineItem(value).subscribe((res: any) => {
        this.itemSuggestions = res?.response?.body?.items || [];
        this.showSuggestionList = true;
      });
    }, 300);  // debounce time
  } else {
    this.itemSuggestions = [];
    this.showSuggestionList = false;
  }
}

selectItem(item: any) {
  this.itemForm.patchValue({ itemName: item.name });
  this.showSuggestionList = false;
  console.log('Selected item:', item);
}

// hideSuggestions() {
//   setTimeout(() => {
//     this.showSuggestionList = false;
//   }, 200);
// }

showSuggestions() {
  if (this.itemSuggestions.length > 0) {
    this.showSuggestionList = true;
  }
}
  // =========================END OF CODE  FOR SEARCH BY PART-NO AND PART NAME WHILE CREATING ITEM MANUALLY============================
// ============item level discount====================
// calculateItemDiscountPreview(index: number): void {
//   const quote = this.customerQuotation?.[index];
//   const formGroup = this.quoteFormArray?.at(index) as FormGroup;

//   if (!quote || !formGroup) {
//     console.warn(`Missing quote or form group at index: ${index}`);
//     return;
//   }

//   const discountValue = Number(formGroup.get('discountValue')?.value || 0);
//   const discountPercentage = Number(formGroup.get('discountPercentage')?.value || 0);
//   const totalMrp = quote.mrp * quote.itemQuantity;

//   // Reset validation flag
//   quote.isDiscountInvalid = false;

//   // Validation checks
//   if (discountValue > totalMrp || discountPercentage > 100) {
//     quote.isDiscountInvalid = true;
//   }

//   // Calculate rupees and percent for preview
//   quote.discountInRupees = discountValue || (discountPercentage / 100) * totalMrp;
//   quote.discountInPercent = discountPercentage || (discountValue / totalMrp) * 100;
// }

// getControlValue(i: number, controlName: string): any {
//   if (this.quoteFormArray && this.quoteFormArray.controls[i]) {
//     const control = this.quoteFormArray.controls[i].get(controlName);
//     return control ? control.value : null;
//   }
//   return null;
// }
//     updateItemTotal(index: number) {
//       const discount = this.quoteFormArray.at(index).value;
//       this.recalculateMrpWithDiscount(index, discount);
//       this.updateSelectedItemsQuote();
//     }


//     recalculateMrpWithDiscount(index: number, discount: { discountValue: number; discountPercentage: number }) {
//       const item = this.customerQuotation[index];
//       const originalMrp = item.originalMrp || item.mrp;

//       if (discount.discountPercentage && discount.discountPercentage > 0) {
//         const discounted = originalMrp - (originalMrp * discount.discountPercentage / 100);
//         item.mrp = parseFloat(discounted.toFixed(2));
//       } else if (discount.discountValue && discount.discountValue > 0) {
//         const discounted = originalMrp - discount.discountValue;
//         item.mrp = parseFloat(discounted.toFixed(2));
//       } else {
//         item.mrp = originalMrp;
//       }
//       this.getQuoteGrandTotal();
//       this.updateSelectedItemsQuote();
//       this.updateSelectedLabourItems();
//     }
    
// onDiscountValueInput(index: number) {
//   const group = this.quoteFormArray.at(index);
//   if (+group.get('discountValue')?.value > 0) {
//     group.patchValue({ discountPercentage: 0 }, { emitEvent: false });
//   }
//   this.updateItemTotal(index);
// }

// onDiscountPercentageInput(index: number) {
//   const group = this.quoteFormArray.at(index);
//   if (+group.get('discountPercentage')?.value > 0) {
//     group.patchValue({ discountValue: 0 }, { emitEvent: false });
//   }
//   this.updateItemTotal(index);
// }
calculateItemDiscountPreview(index: number): void {
  const quote = this.customerQuotation[index];
  const formGroup = this.quoteFormArray.at(index) as FormGroup;

  const discountValue = Number(formGroup.get('discountValue')?.value || 0);
  const discountPercentage = Number(formGroup.get('discountPercentage')?.value || 0);

  const basePrice = quote.originalSellingPrice || quote.mrp || 0;
  const quantity = quote.quantity || 1;
  const totalBasePrice = basePrice * quantity;

  // Reset invalid flag
  quote.isDiscountInvalid = false;

  // Validate discount limits
  if (discountValue > totalBasePrice || discountPercentage > 100) {
    quote.isDiscountInvalid = true;
    // Optionally, don't apply discount if invalid
    quote.sellingPrice = basePrice; 
    return;
  }

  let totalDiscount = discountValue;
  if (discountValue === 0 && discountPercentage > 0) {
    totalDiscount = (discountPercentage / 100) * totalBasePrice;
  }

  // Calculate per item discount
  const perItemDiscount = totalDiscount / quantity;

  // Calculate final selling price per item
  quote.sellingPrice = parseFloat((basePrice - perItemDiscount).toFixed(2));

  this.getQuoteGrandTotal();
  this.updateSelectedItemsQuote();
  this.updateSelectedLabourItems();
}

getControlValue(index: number, controlName: string): boolean {
  return this.quoteFormArray.at(index).get(controlName)?.value > 0;
}


// onDiscountValueInput(index: number) {
//   const group = this.quoteFormArray.at(index);
//   if (+group.get('discountValue')?.value > 0) {
//     group.patchValue({ discountPercentage: 0 }, { emitEvent: false });
//   }

//   const discount = {
//     discountValue: +group.get('discountValue')?.value || 0,
//     discountPercentage: 0,
//   };
//   this.recalculateMrpWithDiscount(index, discount);
// }

// onDiscountPercentageInput(index: number) {
//   const group = this.quoteFormArray.at(index);
//   if (+group.get('discountPercentage')?.value > 0) {
//     group.patchValue({ discountValue: 0 }, { emitEvent: false });
//   }

//   const discount = {
//     discountValue: 0,
//     discountPercentage: +group.get('discountPercentage')?.value || 0,
//   };
//   this.recalculateMrpWithDiscount(index, discount);
// }



onDiscountValueInput(i: number) {
  const control = this.mainForm.get(['quoteFormArray', i]) as FormGroup;
  const value = +control.get('discountValue')?.value || 0;

  // Clear percentage field
  control.get('discountPercentage')?.setValue(0, { emitEvent: false });

  const item = this.customerQuotation[i];
  const mrp = (+item.mrp || 0)* (item.quantity);
  const originalMrp = item.originalMrp ?? item.mrp ?? 0;

  // Calculate percentage from value
  let discountPercentage = mrp > 0 ? (value / mrp) * 100 : 0;
  discountPercentage = parseFloat(discountPercentage.toFixed(2)); // round to 2 decimal places

  control.get('discountPercentage')?.setValue(discountPercentage, { emitEvent: false });

  item.discountValue = Math.round(value); // round off to nearest integer
  item.discountType = value > 0 ? 'rupees' : null;
  item.isDiscountInvalid = value > mrp;

  if (!item.isDiscountInvalid) {
    this.recalculateMrpWithDiscount(i, {
      discountValue: item.discountValue,
      discountPercentage,
    });
  }
}



onDiscountPercentageInput(i: number) {
  const control = this.mainForm.get(['quoteFormArray', i]) as FormGroup;
  let discountPercentage = +control.get('discountPercentage')?.value || 0;
  discountPercentage = parseFloat(discountPercentage.toFixed(2)); // round to 2 decimal places

  const item = this.customerQuotation[i];
  const mrp = (+item.mrp || 0) * (item.quantity);
  let discountValue = discountPercentage > 0 ? (mrp * discountPercentage) / 100 : 0;
  discountValue = Math.round(discountValue); // round to nearest integer

  control.get('discountValue')?.setValue(discountValue, { emitEvent: false });

  item.discountValue = discountValue;
  item.discountType = discountPercentage > 0 ? 'percentage' : null;
  item.isDiscountInvalid = discountPercentage > 100;

  console.log("onDiscountPercentageInput edit quotation:", this.customerQuotation);

  if (!item.isDiscountInvalid) {
    this.recalculateMrpWithDiscount(i, {
      discountValue,
      discountPercentage,
    });
  }
}

recalculateMrpWithDiscount(index: number, discount: {discountValue: number, discountPercentage: number}) {
  const item = this.customerQuotation[index];
  if (!item) return;

  let discountAmount = 0;
  if (discount.discountPercentage && discount.discountPercentage > 0) {
    discountAmount = (item.mrp || 0) * (discount.discountPercentage / 100);
  } else if (discount.discountValue && discount.discountValue > 0) {
    discountAmount = discount.discountValue;
  }

  let newSellingPrice = (item.mrp || 0) - discountAmount;
  if (newSellingPrice < 0) newSellingPrice = 0;

  // Update the item immutably for change detection
  this.customerQuotation[index] = {
    ...item,
    sellingPrice: newSellingPrice,
    discountValue: discount.discountValue,
    discountPercentage: discount.discountPercentage,
  };

  // Also update discount validity flag if you want here
  this.customerQuotation[index].isDiscountInvalid = 
    discount.discountValue > item.mrp * (item.quantity || 1) || discount.discountPercentage > 100;

  // Optional: recalculate totals, update UI summaries
  this.calculateItemDiscountPreview(index);

  // Force Angular to detect changes if OnPush strategy is used
  // this.cdRef.detectChanges();  // if you have ChangeDetectorRef injected as cdRef
}


}

